// src/pages/RegistrationFuiteDonnees/components/UI/Checkbox.tsx
import React from 'react';
import './Checkbox.scss';

interface CheckboxProps {
  id: string;
  name: string;
  label: React.ReactNode;
  required?: boolean;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({
                                             id,
                                             name,
                                             label,
                                             required = false,
                                             checked,
                                             onChange
                                           }) => {
  return (
    <div className="UI-checkbox">
      <div className="checkbox">
        <input
          type="checkbox"
          id={id}
          name={name}
          required={required}
          checked={checked}
          onChange={onChange}
          className="checkbox__input"
        />

        <label htmlFor={id} className="checkbox__label">
          <span className="checkbox__custom"></span>
          {label}
        </label>
      </div>
    </div>
  );
};

export default Checkbox;